import Vue from 'vue';
import App from './App';
import { router } from './router';
import '@/styles/index.scss'; // global css
import 'amfe-flexible';
// import Vconsole from 'vconsole';
// new Vconsole();
new Vue({
  router,
  el: '#app',
  render: (h) => h(App),
});
